function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Icon awesome-video",
    d: "M11.674 4.5H1.66A1.629 1.629 0 0 0 0 6.1v9.63a1.629 1.629 0 0 0 1.66 1.6h10.014a1.629 1.629 0 0 0 1.66-1.6V6.1a1.629 1.629 0 0 0-1.66-1.6zm6.576 1.259-3.806 2.524v5.256l3.806 2.521A1.117 1.117 0 0 0 20 15.2V6.62a1.117 1.117 0 0 0-1.75-.861z",
    transform: "translate(2 1.089)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.19d9c42a450c4eec63e9a6fdbd25738c.svg";
export { ForwardRef as ReactComponent };